import axios from 'axios';

export type PermissionsType = {
  lockboxId: string;
  permissionType: 'owner' | 'assignee';
};

const assignSupraLockbox = async ({
  userId,
  permissions,
}: {
  userId: string;
  permissions: PermissionsType[];
}) => {
  await axios.post('/supra/lockbox/assign_user', {
    userId,
    permissions,
  });
};

export default assignSupraLockbox;
